import React, { useCallback, useEffect, useState } from 'react';
import { ImagePreviewProps } from './types';
import { CardMedia } from '@mui/material';
import { Skeleton } from '@mui/material';
import { getBase64Image } from './util';

const ImagePreview: React.FunctionComponent<ImagePreviewProps> = (props) => {
  const { fileContent, height, size, className } = props;
  const [url, setUrl] = useState<string>();
  const [loading, setLoading] = useState(Boolean);

  const uploadSiteImages = useCallback(
    (path) => {
      setLoading(true);
      getBase64Image(path, size!).then((base64Image) => {
        setUrl(base64Image);
        setLoading(false);
      });
    },
    [size]
  );

  useEffect(() => {
    typeof fileContent !== 'string' && uploadSiteImages(fileContent?.path);
  }, [fileContent, uploadSiteImages]);

  const renderImagePreview = () => {
    return (
      <>
        {loading ? (
          <Skeleton
            sx={{ height: height }}
            animation='wave'
            variant='rectangular'
            className={className}
          />
        ) : (
          <CardMedia
            component='img'
            height={height}
            alt='image'
            image={url ? `data:${fileContent?.contentType};base64,${url}` : fileContent}
            className={className}
          />
        )}
      </>
    );
  };
  return renderImagePreview();
};

export default ImagePreview;
